import { render, staticRenderFns } from "./TransportSuggest.vue?vue&type=template&id=23e43b18&scoped=true&"
import script from "./TransportSuggest.vue?vue&type=script&lang=js&"
export * from "./TransportSuggest.vue?vue&type=script&lang=js&"
import style0 from "./TransportSuggest.vue?vue&type=style&index=0&id=23e43b18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e43b18",
  null
  
)

export default component.exports